<template>
  <figure v-if="post" ref="project" :class="{ pause: paused }">
    <div v-if="paused && isMobile" class="mobile-play"></div>
    <video
      ref="videoPlayer"
      :class="{ pause: paused }"
      draggable="false"
      @click="playPause"
      @ended="resetVideo"
      :poster="post.poster.url"
    >
      <source :src="post.url" type="video/mp4" />
    </video>
  </figure>
</template>

<script>
import { isMobile } from "mobile-device-detect";
export default {
  name: "video-view",
  props: {
    post: Object
  },
  data() {
    return {
      paused: true
    };
  },
  mounted() {
    this.$root.$on("slideChanged", this.stopVideo);
  },
  computed: {
    player() {
      return this.$refs.videoPlayer;
    },
    isMobile() {
      return isMobile;
    }
  },
  methods: {
    playPause() {
      if (!this.paused) {
        this.paused = true;
        // console.log("pause", this.paused);
        this.player.pause();
      } else {
        this.paused = false;
        // console.log("play", this.paused);
        this.player.play();
      }
    },
    stopVideo() {
      // console.log("stop video");
      this.player.pause();
      this.paused = true;
    },
    resetVideo() {
      // console.log("reset video");
      this.player.currentTime = 0;
      this.paused = true;
    }
  }
};
</script>

<style lang="scss" scoped>
figure {
  position: relative;
  width: 100%;
  height: 100%;
  // cursor: url("data:image/svg+xml;charset=UTF-8,%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='20px' height='25px' viewBox='0 0 81.2 99.8' style='enable-background:new 0 0 81.2 99.8;' xml:space='preserve'%3e%3cdefs%3e%3c/defs%3e%3crect width='30.3' height='99.8'/%3e%3crect x='50.9' width='30.3' height='99.8'/%3e%3c/svg%3e")
  //     10 12,
  //   pointer;
  // &.pause {
  //   cursor: url("data:image/svg+xml;charset=UTF-8,%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='25px' height='25px' viewBox='0 0 100 99.8' style='enable-background:new 0 0 100 99.8;' xml:space='preserve'%3e%3cdefs%3e%3c/defs%3e%3cg%3e%3cpath d='M0,0l100,49.9L0,99.8V0z'/%3e%3c/g%3e%3c/svg%3e ")
  //       12 12,
  //     pointer;
  // }
  .mobile-play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 24px;
    height: 24px;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='25px' height='25px' viewBox='0 0 100 99.8' style='enable-background:new 0 0 100 99.8;' xml:space='preserve'%3e%3cdefs%3e%3c/defs%3e%3cg%3e%3cpath d='M0,0l100,49.9L0,99.8V0z'/%3e%3c/g%3e%3c/svg%3e ");
    z-index: 1;
  }
}
video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
